import { Box } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  HStack,
  VStack,
  NextLink,
  getCdnImageSrc,
  EventProps,
} from "goi_common";
import { ReactNode } from "react";
import { CSSObject } from "@emotion/react";

export const ParlorDetailUvGuidebookBanner = ({
  href,
  topNode,
  bottomNode,
  backgroundImageSrc,
  event,
}: {
  href: string;
  topNode?: ReactNode;
  bottomNode: ReactNode;

  backgroundImageSrc: string;
  event: EventProps;
}) => {
  return (
    <HStack justifyContent="center" margin="0px 20px">
      <NextLink
        href={href}
        event={event}
        css={{
          width: "100%",
          background: colors.white,
        }}
      >
        <VStack
          alignItems="flex-start"
          height="100%"
          css={{
            position: "relative",
            padding: "20px 10px 20px 20px",
            minHeight: "90px",
            borderRadius: "10px",
            boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.10)",
            overflow: "hidden",
          }}
        >
          <Box
            css={{
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              width: "235px",
              backgroundImage: `url(${getCdnImageSrc(backgroundImageSrc)})`,
              backgroundPosition: "right",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          />
          <Box
            css={{
              position: "absolute",
              top: 0,
              left: "calc(100% - 237px)",
              right: 0,
              bottom: 0,
              background: "linear-gradient(270deg, rgba(255, 255, 255, 0.0) 0%, #FFF 100%)",
              zIndex: 1,
            }}
          />
          <VStack justifyContent="center" height="100%">
            {topNode && (
              <div
                className="body_16_m gray800"
                css={{
                  zIndex: 2,
                  position: "relative",
                }}
              >
                {topNode}
              </div>
            )}
            <div className="subtitle_18_sb">
              <UnderLineText
                text={
                  <HStack alignItems="center" gap="5px">
                    {bottomNode}
                    <Box>
                      <ColorIcon
                        name="icon-arrow-right-small-mono"
                        color={colors.gray800}
                        size={16}
                      />
                    </Box>
                  </HStack>
                }
                underLineCSS={{ background: colors.orange350 }}
              />
            </div>
          </VStack>
        </VStack>
      </NextLink>
    </HStack>
  );
};

const UnderLineText = ({ text, underLineCSS }: { text: ReactNode; underLineCSS: CSSObject }) => {
  return (
    <div
      css={{
        position: "relative",
        height: "100%",
      }}
    >
      <div css={{ zIndex: 2, position: "relative" }}>{text}</div>
      <Box
        css={{
          zIndex: 1,
          position: "absolute",
          width: "155px",
          height: "11px",
          bottom: 0,
          background: colors.orange500,
          ...underLineCSS,
        }}
      />
    </div>
  );
};
